import React from 'react';

/**
 * Renders nothing and redirects the browser to an external URL.
 * Used to point migrated routes (e.g. SPOC) at their new external home.
 */
export const ExternalRedirect = ({ url }: { url: string }): null => {
  React.useEffect(() => {
    window.location.replace(url);
  }, [url]);
  return null;
};
